var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFileImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16.875H26.25H18.75ZM18.75 30H41.25H18.75ZM18.75 37.5H41.25H18.75ZM18.75 45H26.25H18.75ZM15 54.375H45C45.9946 54.375 46.9484 53.9799 47.6516 53.2766C48.3549 52.5734 48.75 51.6196 48.75 50.625V9.375C48.75 8.38044 48.3549 7.42661 47.6516 6.72335C46.9484 6.02009 45.9946 5.625 45 5.625H15C14.0054 5.625 13.0516 6.02009 12.3483 6.72335C11.6451 7.42661 11.25 8.38044 11.25 9.375V50.625C11.25 51.6196 11.6451 52.5734 12.3483 53.2766C13.0516 53.9799 14.0054 54.375 15 54.375Z",
    fill: "#DFF1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16.875H26.25M18.75 30H41.25M18.75 37.5H41.25M18.75 45H26.25M15 54.375H45C45.9946 54.375 46.9484 53.9799 47.6516 53.2766C48.3549 52.5734 48.75 51.6196 48.75 50.625V9.375C48.75 8.38044 48.3549 7.42661 47.6516 6.72335C46.9484 6.02009 45.9946 5.625 45 5.625H15C14.0054 5.625 13.0516 6.02009 12.3483 6.72335C11.6451 7.42661 11.25 8.38044 11.25 9.375V50.625C11.25 51.6196 11.6451 52.5734 12.3483 53.2766C13.0516 53.9799 14.0054 54.375 15 54.375Z",
    stroke: "#139CFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 17.8125C41.7678 17.8125 42.1875 17.3928 42.1875 16.875C42.1875 16.3572 41.7678 15.9375 41.25 15.9375C40.7322 15.9375 40.3125 16.3572 40.3125 16.875C40.3125 17.3928 40.7322 17.8125 41.25 17.8125Z",
    fill: "#139CFF",
    stroke: "#139CFF",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFileImg);
export default __webpack_public_path__ + "static/media/add-file-img.d1b64808dd38da1c759b175cbc19f85a.svg";
export { ForwardRef as ReactComponent };